import React from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import * as styles from './product-tour.module.css';
//@ts-ignore
import {
    KontentStringValue,
    KontentMedia,
    CTALocation,
    KontentProductImage,
    KontentRadioMultiChoice,
} from '../../../types/KontentProps';
import CtaLink from '../Global/CtaLink';
import { getMediaData, getMultiChoice } from '../Global/DataUtils';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import { getDevicePlatform } from '../../global/utility';
interface Props {
    cta_configuration__cta_label?: KontentStringValue;
    cta_configuration__cta_location?: CTALocation;
    cta_configuration__cta_window_action?: {
        value: {
            codename: 'same_window' | 'new_window';
        }[];
    };
    show_hide_cta?: KontentRadioMultiChoice<'show' | 'hide'>;
    cta_configuration__cta_location_anchor_point: {
        value: string;
    };
    cta_copy: KontentStringValue;
    cta_icons: KontentProductImage;
    sku: KontentStringValue;
    ua_code: KontentStringValue;
    ga_measurement_id: KontentStringValue;
    product_tour_sku: KontentStringValue;
    foreground_image: KontentMedia;
    component_anchor_name: KontentStringValue;
}

const ProductTour: React.FC<Props> = ({
    cta_configuration__cta_label,
    cta_configuration__cta_location,
    cta_configuration__cta_window_action,
    cta_copy,
    cta_icons,
    sku,
    ua_code,
    cta_configuration__cta_location_anchor_point,
    ga_measurement_id,
    product_tour_sku,
    foreground_image,
    component_anchor_name,
    show_hide_cta,
}) => {
    const anchor_name = component_anchor_name?.value;
    const ctaCopy = cta_copy?.value;
    const epigraphCtaBoxIcon =
        cta_icons?.value[0]?.elements?.file?.value[0]?.url;
    const epigraphCtaBoxHoverIcon =
        cta_icons?.value[1]?.elements?.file?.value[0]?.url;
    const ctaAnchorValue = cta_configuration__cta_location_anchor_point?.value;
    const getPricingCtaTarget =
        getMultiChoice(cta_configuration__cta_window_action) === 'new_window'
            ? '_new'
            : '_self';

    const showGetPricing =
        getMultiChoice(show_hide_cta) === 'show' ? true : false;
    const epigraphCtaSku = sku?.value;
    const epigraphUaCode = ua_code?.value;
    const foreGroundImage = getMediaData(foreground_image);

    const renderProductTour = () => {
        if (typeof window != 'undefined' && getDevicePlatform.any()) {
            return (
                <div className={styles.mobileProductTourContainer}>
                    <epigraph-ar
                        viewer-visible
                        product-tour-visible
                        button-mode="none"
                        sku={product_tour_sku?.value}
                        ua-code={epigraphUaCode}
                        camera-orbit="-45deg 90deg 6m"
                        ga4-code={ga_measurement_id?.value}
                        ga-measurement-id={ga_measurement_id?.value}
                    >
                        <button
                            slot="mobile-product-tour-button"
                            style={{ zIndex: 1 }}
                        >
                            <picture className={styles.picture}>
                                <img
                                    src={foreGroundImage?.url}
                                    alt="mobile-product-tour-image"
                                />
                            </picture>
                        </button>
                    </epigraph-ar>
                </div>
            );
        } else {
            return (
                <epigraph-ar
                    viewer-visible
                    product-tour-visible
                    button-mode="none"
                    sku={product_tour_sku?.value}
                    ua-code={epigraphUaCode}
                    camera-orbit="-45deg 90deg 6m"
                    ga-measurement-id={ga_measurement_id?.value}
                    auto-start
                ></epigraph-ar>
            );
        }
    };

    return (
        <section id={anchor_name || undefined}>
            <div className={styles.productTourContainer}>
                <div className={styles.productTour}>{renderProductTour()}</div>
                <div className={styles.links}>
                    {showGetPricing && (
                        <div className={styles.getpricingcta}>
                            <CtaLink
                                href={
                                    cta_configuration__cta_location_anchor_point?.value
                                        ? BuildLinkHref(
                                              cta_configuration__cta_location
                                          ) +
                                          '#' +
                                          cta_configuration__cta_location_anchor_point?.value
                                        : BuildLinkHref(
                                              cta_configuration__cta_location
                                          )
                                }
                                target={getPricingCtaTarget}
                            >
                                {cta_configuration__cta_label.value}
                            </CtaLink>
                        </div>
                    )}
                    <div className={styles.viewSauna}>
                        <epigraph-ar
                            sku={epigraphCtaSku}
                            ua-code={epigraphUaCode}
                            ga-measurement-id={ga_measurement_id?.value}
                        >
                            <button
                                slot="ar-button"
                                className={styles.epigraphBtn}
                            >
                                <span className={styles.boxIcons}>
                                    <img src={epigraphCtaBoxIcon} />
                                    <img src={epigraphCtaBoxHoverIcon} />
                                </span>
                                <span>{ctaCopy}</span>
                            </button>
                        </epigraph-ar>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductTour;

export const fragmentProductTour = graphql`
    fragment ProductTour on kontent_item_component___product_tour {
        elements {
            component_anchor_name {
                value
            }
            cta_configuration__cta_label {
                value
            }
            cta_configuration__cta_location {
                ...kontentCtaLocation
            }
            cta_configuration__cta_location_anchor_point {
                value
            }
            cta_configuration__cta_window_action {
                value {
                    codename
                }
            }
            cta_copy {
                value
            }
            cta_icons {
                value {
                    ... on kontent_item_media___image {
                        elements {
                            file {
                                value {
                                    url
                                }
                            }
                        }
                    }
                }
            }
            sku {
                value
            }
            ua_code {
                value
            }
            product_tour_sku {
                value
            }
            ga_measurement_id {
                value
            }
            foreground_image {
                ...kontentImage
            }
            show_hide_cta {
                value {
                    codename
                }
            }
        }
    }
`;
